enum Issues {
  BUG = 'Bug',
  COMPLAINT = 'Complaint',
  FEEDBACK = 'Feedback',
  OTHER = 'Other',
  REQUEST = 'Request',
}

export default Issues;
